import $ from "cash-dom";
import Cookies from "js-cookie";
import anime from "animejs";

export const cookiesListComponent = async () => {
  $(".cookies-list").each((n, el) => {
    const $root = $(el);
    const $labels = $root.find(".cookies-list-label");
    const $labelsRoot = $root.find(".cookies-list-labels-root");
    const $activeLabelBg = $root.find(".cookies-list-active-label-bg");
    const $targets = $root.find('[id^="cookies-list-item-"]');

    const activateLabel = (labelEl) => {
      if (!labelEl) return;

      const $label = $(labelEl);
      const targetId = $label.attr("data-target-id");
      if (!targetId) return;

      const $target = $targets.filter(`#${targetId}`);
      if ($target.length === 0) return;

      $labels
        .removeClass("text-red font-semibold")
        .addClass("text-gray font-normal");
      $label
        .addClass("text-red font-semibold")
        .removeClass("text-gray font-normal");

      $targets.addClass("hidden");
      $target.removeClass("hidden");

      // show/hide panels
      $targets.addClass("hidden");
      $target.removeClass("hidden");

      // aria state for screen readers
      $root.find(".cookies-setting-input").attr("aria-expanded", "false");
      $label.find(".cookies-setting-input").attr("aria-expanded", "true");

      // (you can keep aria-expanded on labels too if you want, but checkbox is the important one)

      $labels.attr("aria-expanded", "false");
      $label.attr("aria-expanded", "true");

      anime({
        targets: $activeLabelBg.get(),
        top: $label.offset().top - $labelsRoot.offset().top,
        duration: 250,
        easing: "easeOutQuad",
      });
    };

    // mouse hover highlights / switches panel
    $labels.on("mouseenter", (e) => activateLabel(e.currentTarget));

    // click anywhere in label switches panel (and also toggles checkbox normally)
    $labels.on("click", (e) => activateLabel(e.currentTarget));

    // IMPORTANT: when keyboard focuses the checkbox, switch the panel
    $root.find(".cookies-setting-input").each((i, inputEl) => {
      inputEl.addEventListener("focus", () => {
        activateLabel(inputEl.closest(".cookies-list-label"));
      });
      inputEl.addEventListener("change", () => {
        activateLabel(inputEl.closest(".cookies-list-label"));
      });
    });
  });
};

export const cookiesBarComponent = async () => {
  const $root = $(".cookies");
  const $bar = $root.find(".cookies-bar");
  const $info = $root.find(".cookies-info");
  const $settings = $root.find(".cookies-settings");

  const settings = {
    1: false,
    2: false,
    4: false,
    8: false,
  };

  const domain = $root.attr("data-domain");
  const secure = $root.attr("data-secure") === "https";

  // push initial state
  {
    const value = Cookies.get("cookie_policy");
    if (window.dataLayer) {
      window.dataLayer.push({ event: "CookiePreference" + (value ?? "15") });
    }
  }

  const setCookie = (value) => {
    Cookies.set("cookie_policy", value.toString(), {
      domain,
      sameSite: secure ? "None" : "Lax",
      secure,
      expires: 365 * 10,
    });

    if (window.dataLayer) {
      window.dataLayer.push({ event: "CookiePreference" + value.toString() });
    }

    $bar.toggleClass("hidden");
  };

  // buttons
  $root.find(".cookies-reject").on("click", () => setCookie(0));
  $root.find(".cookies-accept").on("click", () => setCookie(15));

  $root.find(".cookies-toggle-settings").on("click", () => {
    $info.toggleClass("hidden");
    $settings.toggleClass("hidden");

    // when settings open, ensure list behavior is active + focus is meaningful
    // (optional but helpful)
    const firstLabel = $root.find(".cookies-list-label").get(0);
    if (firstLabel) firstLabel.focus();
  });

  $root.find(".cookies-set-custom").on("click", () => {
    let value = 0;
    if (settings["1"]) value += 1;
    if (settings["2"]) value += 2;
    if (settings["4"]) value += 4;
    if (settings["8"]) value += 8;
    setCookie(value);
  });

  // init list switching behavior
  await cookiesListComponent();

  // IMPORTANT:
  // Your inputs have tabindex="-1" and aria-hidden="true".
  // They still fire "change" when clicked via label with a mouse.
  // If you also want keyboard users to toggle preferences, you need a different UI
  // (e.g., real focusable checkboxes or separate toggle buttons).
  $root.find(".cookies-setting-input").on("change", (event) => {
    const $input = $(event.target);
    settings[$input.attr("data-setting")] = $input.prop("checked");
  });

  // show bar if no cookie exists
  if (Cookies.get("cookie_policy") === undefined) {
    $bar.toggleClass("hidden");
  }

  // unhide wrapper (you had display:none initially)
  $root.get(0).style.display = "";

  window.CookieBar = {
    open: () => $bar.removeClass("hidden"),
    close: () => $bar.addClass("hidden"),
  };
};
